import { useState } from 'react';

import { Button } from '@components/button';
import { ButtonVariant } from '@components/button/button';
import { IconShare } from '@components/icons/share';
import { useClipboard } from '@hooks/use-clipboard';
import { useScopedTranslate } from '@locale/translate';

import { JourneyForm } from 'api/journey-forms/requests';
import { config } from 'app-config';

import { buildJourneyFormUrl } from './build-journey-form-url';
import { useShareJourneyFormModal } from './share-journey-form-modal';

const FORMS_BASE = config.FORMS_URL;

export const ShareJourneyFormButton = ({
  journeyForm,
  variant = 'ghost',
}: {
  journeyForm?: JourneyForm;
  variant?: ButtonVariant;
}) => {
  const { t } = useScopedTranslate(locale);
  const [justOpenedModal, setJustOpenedModal] = useState(false);
  const { onCopy } = useClipboard();
  const showShareModal = useShareJourneyFormModal();

  return (
    <Button
      isDisabled={!journeyForm?.isPublished}
      iconLeft={<IconShare />}
      variant={variant}
      text={t('shareText')}
      tooltip={
        justOpenedModal
          ? undefined
          : !journeyForm
            ? t('notSaved')
            : !journeyForm.isPublished
              ? t('notActive')
              : t('share')
      }
      preventDefault
      stopPropagation
      onClick={(event) => {
        if (journeyForm) {
          (event.currentTarget as HTMLButtonElement).blur();
          setJustOpenedModal(true);
          const url = buildJourneyFormUrl(FORMS_BASE, journeyForm);
          onCopy(url, t('copy'));
          showShareModal({ journeyForm });
        }
      }}
      onMouseEnter={() => setJustOpenedModal(false)}
      onBlur={() => {
        if (justOpenedModal) {
          setJustOpenedModal(false);
        }
      }}
    />
  );
};

const locale = {
  en: {
    notSaved: 'Form needs to be named and saved before it can be shared',
    notActive: 'Form needs to be active before it can be shared',
    share: 'Share form submission link',
    copy: 'Form submission link copied to clipboard',
    shareText: 'Share',
  },
};
